import React, { Component } from 'react';

export class Home extends Component {
  static displayName = Home.name;

  render() {
    return (
      <div>
        <h1>React Spa</h1>
        <p>Single page application built using ReactJs</p>
      </div>
    );
  }
}
